export const modifyPixelToken = (
  token: string,
  amountToChange: number,
): string => {
  const newNumber = parseInt(token.replace('px', '')) + amountToChange;
  return newNumber.toString() + 'px';
};
